import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { useAuth } from '@modules/auth/hooks';
import { STUDY_INSIGHTS_KIT_FAILURE_REASON_QUERY_KEY } from '../constants/api';
import { fetchKitFailureReason } from '../services/kit-failure-reason.service';
import { KitFailureReasonResponse, KitFailureReasonParams } from '../types';

const useQueryKitFailureReason = <TError = unknown>(
  params: KitFailureReasonParams,
  options?: Omit<
    UseQueryOptions<
      KitFailureReasonResponse | undefined,
      TError,
      KitFailureReasonResponse | undefined,
      Array<string | KitFailureReasonParams>
    >,
    'initialData' | 'queryFn' | 'queryKey'
  >,
): UseQueryResult<KitFailureReasonResponse | undefined> => {
  const { isAuthenticated } = useAuth();

  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;

  return useQuery(
    [STUDY_INSIGHTS_KIT_FAILURE_REASON_QUERY_KEY, params],
    async () => await fetchKitFailureReason(params),
    {
      ...options,
      enabled: isAuthenticated === true && enabledOption,
    },
  );
};

export default useQueryKitFailureReason;
